<template>
  <v-data-table
    :headers="headers"
    :items="users"
    item-key="id"
    :items-per-page="50"
    class="mb-8"
  >
    <template v-slot:top>
      <v-dialog
        v-model="loading"
        persistent
        width="300"
      >
        <v-card height="190" class="text-center">
          <v-progress-circular
            :indeterminate="loading"
            :size="100"
            color="primary"
            class="mt-4 "
          >Loading...
          </v-progress-circular>
          <v-card-actions>
            <v-btn class="ml-auto my-2" color="primary" @click="loading=false">close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </v-data-table>
</template>

<script>
  import mixin from '@/util/mixin'

  export default {
    mixins: [mixin],
    data () {
      return {
        editedIndex: -1,
        editedItem: {},
        loading: true,
        headers: [
          { text: 'ユーザーID', value: 'uid', sortable: false },
          { text: 'イベント名', value: 'name', sortable: false },
          { text: '発生日時', value: 'occurred_at', sortable: false },
        ],
        users: []
      }
    },
    methods: {
      init () {
        this.$fb.getDocs(this.$fb.query(this.$fb.collection(this.$fb.firestore, 'client_breadcrumbs'),
          this.$fb.limit(1000)))
        .then(async (userSnap) => {
          const users = await Promise.all(userSnap.docs
            .filter((userDoc) => userDoc.id.length !== 5)
            .map(async (userDoc) => {
              const userData = userDoc.data()
              return {...userData, occurred_at: userData.at.toDate()}
            })
          )
          users.sort((a, b) => !a.at ? 1 : !b.at ? -1 : b.at.toDate().getTime() - a.at.toDate().getTime())
          this.users = users
          this.loading = false
        }).catch(error => {
          console.error(error)
          this.users = []
          this.loading = false
        })
      },
    },
    created () {
      this.init()
    }
  }
</script>